import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project, Status } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  statuses: Identifiable<Status>[];
  retrieveTaskStatuses(
    request: Boundaries["retrieveTaskStatuses"]["request"],
  ): void;
}

function useTaskStatusesRetrieval(project: Identifiable<Project>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isTaskStatusesRetrievalRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isTaskStatusesRetrievalRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isTaskStatusesRetrievalRequestFailure(project),
    ),
    statuses: useSelector(() => selector.getTaskStatuses(project)),
    retrieveTaskStatuses: core.retrieveTaskStatuses,
  };
}

export { useTaskStatusesRetrieval };
